import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconWeb = ({ id, color, width = 20, style, ...restProps }: IProps) => {
  const viewBoxWidth = 20;
  const viewBoxHeight = 14;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M19.5 12.8L17.9 10c.1-.2.1-.4.1-.6v-8c0-.8-.7-1.4-1.5-1.4H2.9c-.8 0-1.4.6-1.4 1.4v8c0 .2.1.5.2.7l-1.2 2-.4.8c-.1.1-.1.4 0 .5.1.2.3.3.5.3H19c.2 0 .4-.1.5-.3.1-.1.1-.4 0-.6zM2.7 1.4c0-.1.1-.2.2-.2h13.7c.1 0 .2.1.2.2v8c0 .1-.1.2-.2.2H2.9c-.1 0-.2-.1-.2-.2v-8zm-1 11.1l1-1.6H17l.9 1.7H1.7z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconWeb;
